import React from "react";
import { Helmet } from "react-helmet";
const WebdevHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Best Website Development Services in USA
      </title>
      <meta
        name="description"
        content="Leading website development services in USA. Reach out today to build custom, results-driven websites, boost online presence, and drive business growth."
      />
    </Helmet>
  );
};

export default WebdevHelmet;
